import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMarkupPhoto360 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M22.05 6.75q0-.8-.6-1.4-.55-.6-1.4-.6-.5 0-1 .25-2.95-2.95-7-2.95-4.15 0-7.1 2.95-2.9 2.9-2.9 7.05t2.9 7.1q2.95 2.9 7.1 2.9t7.05-2.9q2.95-2.95 2.95-7.1 0-1.85-.75-3.75.75-.6.75-1.55M10.6 9.35q.6-.6 1.45-.6h.65v1.3h-.65q-.7 0-.7.7v.65h.7q.85 0 1.4.6.6.6.6 1.4 0 .85-.6 1.4-.55.6-1.4.6t-1.45-.6q-.55-.55-.55-1.4v-2.65q0-.85.55-1.4m9.45-1.95q-.7 0-.7-.65 0-.7.7-.7.65 0 .65.7 0 .65-.65.65m-4.7 3.35q0-.8.6-1.4t1.4-.6q.85 0 1.4.6.6.6.6 1.4v2.65q0 .85-.6 1.4-.55.6-1.4.6-.8 0-1.4-.6-.6-.55-.6-1.4zm-10.65-.7v-1.3h3.35q.4 0 .55.35.2.35-.05.7L7.3 11.5q1.4.45 1.4 1.9 0 .85-.6 1.4-.55.6-1.4.6h-2v-1.35h2q.65 0 .65-.65t-.65-.65h-.65q-.45 0-.6-.4-.2-.3.05-.65l1.2-1.65zm12.65.05q-.65 0-.65.65v2.65q0 .7.65.7t.65-.7v-2.65q0-.65-.65-.65m-4.65 3.3q0-.65-.7-.65h-.65v.65q0 .65.65.65.7 0 .7-.65"
	})
});
export default SvgMarkupPhoto360;
